/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-this-in-sfc */

import './css/modal.scss';
import PropTypes from 'prop-types';
import React from 'react';

function renderModal(prop) {

    if (prop.isOpen) {

        return (
            <div className="modal-wrapper">
                <div className="modal-backdrop-overlay" />
                <div className="modal-dialog">
                    <div className="modal-content">
                        {prop.children}
                    </div>
                </div>
            </div>
        );

    }

    return null;

}

export class Modal extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            isRendered: false,

        };

    }

    componentDidMount() {

        setTimeout(() => {

            this.setState({
                isRendered: true,
            });

        }, 1);

    }

    render() {

        return (
            <>
                <div
                    component="div"
                    className={this.props.className}
                    transitionName="modal"
                >

                    {renderModal(this.props)}

                </div>

            </>

        );

    }

}
Modal.displayName = 'Modal';
Modal.propTypes = {
    className: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    children: PropTypes.node,

};
export default Modal;
